(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sell-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  if (typeof jQuery !== 'undefined' && $('.custom-slick-slider-sell').length) {
    $('.custom-slick-slider-sell').slick({
      dots: true,
      arrows: true,
      autoplay: false,
      autoplaySpeed: 4000,
      slidesToShow: 1,
      slidesToScroll: 1
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-watch-finder"] && !Shopify.designMode) return;
  try {
    
function initWatchFinder(root){
  if(root.dataset.ready)return;root.dataset.ready='true';
  const form=root.querySelector('form'),cards=[...root.querySelectorAll('[data-price]')],count=root.querySelector('[data-count]'),empty=root.querySelector('[data-empty]'),error=root.querySelector('[data-error]');
  function filter(){
    const value=n=>form.elements[n].value.trim(),number=n=>value(n)===''?null:Number(value(n));
    const lo=number('size_min'),hi=number('size_max'),pl=number('price_min'),ph=number('price_max'),mat=value('material');
    if((lo!==null&&hi!==null&&lo>hi)||(pl!==null&&ph!==null&&pl>ph)){error.hidden=false;return;}error.hidden=true;
    let total=0;for(const card of cards){const size=card.dataset.size===''?null:Number(card.dataset.size),price=Number(card.dataset.price);const match=(!mat||card.dataset.material===mat)&&(lo===null||(size!==null&&size>=lo))&&(hi===null||(size!==null&&size<=hi))&&(pl===null||price>=pl)&&(ph===null||price<=ph);card.hidden=!match;if(match)total++;}
    count.textContent=root.querySelector('[data-count-label]').textContent+' '+total;empty.hidden=total!==0;
  }
  form.addEventListener('submit',e=>{e.preventDefault();if(form.reportValidity())filter();});form.addEventListener('change',()=>{if(form.checkValidity())filter();});root.querySelector('[data-clear]').addEventListener('click',()=>{form.reset();filter();});filter();
}
document.querySelectorAll('.tw-finder').forEach(initWatchFinder);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.tw-finder').forEach(initWatchFinder));

  } catch(e) { console.error(e); }
})();
})();
